import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useAppSelector } from '@/store/hooks/useAppSelector.js';
import { getLoggedInUser, getSelectedAgent, getSelectedAgentId } from '@/store/account/selector.js';
import { FC } from 'react';
import { useLocalTimezone } from 'src/common/hooks/useLocalTimezone.js';
import { getResellerData } from '@/store/reseller/selector.js';
import { MessageOutlined } from '@ant-design/icons';
import Header from '@/components/Header/Header.js';
import TextingPlatformArea from './TextingPlatFormArea.js';
import { EPostHogProperties } from 'src/enums/EPostHogProperties.js';
import { EPostHogEvents } from 'src/enums/EPostHogEvents.js';

export const TextingPlatform: FC<{ debrand: boolean; isNoviUser: boolean }> = ({ debrand }) => {
	const loggedInUser = useAppSelector(getLoggedInUser);
	const currentReseller = useAppSelector(getResellerData);
	const selectedAgent = useAppSelector(getSelectedAgent);
	const selectedAgentId = useAppSelector(getSelectedAgentId);

	const { timeZone } = useLocalTimezone(selectedAgent?.time_zone);

	useEffect(() => {
		if (selectedAgentId) {
			console.log('TextingPlatform MOUNTED');
			posthog.capture(EPostHogEvents.TEXTING_AGENT_PAGE_VIEWED, {
				[EPostHogProperties.AGENT_ID]: selectedAgentId,
			});

			const startTime = Date.now();

			return () => {
				console.log('TextingPlatform UNMOUNTING...');
				const endTime = Date.now();
				const durationInSeconds = Math.round((endTime - startTime) / 1000);

				if (durationInSeconds > 1) {
					posthog.capture(EPostHogEvents.TEXTING_AGENT_PAGE_END, {
						[EPostHogProperties.AGENT_ID]: selectedAgentId,
						[EPostHogProperties.DURATION_SECONDS]: durationInSeconds,
					});
				}
			};
		}
	}, [selectedAgentId]);

	return (
		<div>
			<Header
				title="Texting Platform"
				description="Send and receive text messages with ease"
				icon={<MessageOutlined />}
				debrand={debrand}
			/>
			<TextingPlatformArea
				themeColor={'#007bff'}
				premium_customer={
					loggedInUser.resellerClient ||
					(loggedInUser?.inboundSubscriptionStatus &&
						loggedInUser?.inboundSubscriptionStatus !== 'cancelled' &&
						selectedAgent?.type === 'Inbound') ||
					(selectedAgent?.type === 'Outbound' && !loggedInUser.outboundDemo)
				}
				theirNumber={selectedAgent?.number}
				username={selectedAgent?.number}
				selectedTimeZone={timeZone}
				resellerObject={currentReseller}
			/>
		</div>
	);
};
